import { cfg } from '../runtimeConfig';

export const SITE_NAME = cfg('SITE_NAME', process.env.REACT_APP_SITE_NAME) || 'Anuryan E&A Pvt. Ltd.';
export const INSIGHTS_PATH = '/insights';
